<div class="grid grid-cols-[3rem_5rem_1fr] pb-2">
    <div>
        <ng-container *ngIf="delay; else noDelay">
            <span class="flex text-[#414141] dark:text-contrast-yellow">
                {{ realdataStartTime | momentDate: 'HH:mm' : env.TIMEZONE }}
            </span>
            <span
                class="ml-1 flex text-sm text-[#838383] line-through dark:text-contrast-yellow"
                *ngIf="isDelayed"
                [attr.aria-hidden]="true">
                {{ time - (itinerary?.journeyStartDepartureDelay || 0) * 1000 | momentDate: 'HH:mm' : env.TIMEZONE }}
            </span>
        </ng-container>

        <ng-template #noDelay>
            <span class="flex text-[#414141] dark:text-contrast-yellow">
                {{ time | momentDate: 'HH:mm' : env.TIMEZONE }}
            </span>
        </ng-template>
    </div>
    <div class="flex items-end justify-center">
        <ion-icon
            class="text-[1.375rem] text-[#838383] dark:text-contrast-yellow"
            src="{{ assetsPath$ | async }}/img/journey-planner/origin.svg"
            title="{{ 'ORIGIN' | translate }}"
            aria-hidden="true"></ion-icon>
    </div>
    <span class="flex items-end">
        <ng-container *ngIf="legName; else useDefaultOrigin">
            <ng-container [ngSwitch]="legName">
                <span *ngSwitchCase="'LOCATION_FROM_MAP'">{{ 'LOCATION_FROM_MAP' | translate | titlecase }}</span>
                <span *ngSwitchCase="'CURRENT_LOCATION'">{{ 'CURRENT_LOCATION' | translate | titlecase }}</span>
                <span *ngSwitchDefault>{{ legName | titlecase }}</span>
            </ng-container>
        </ng-container>
        <ng-template #useDefaultOrigin>
            {{ 'ITINERARY_INSTRUCTIONS_ORIGIN' | translate | titlecase }}
        </ng-template>
    </span>
</div>
